import { Box, Center, VStack } from "@chakra-ui/react";
import Card from "components/Atomos/Card";

type LoginTemplateProps = {
    header: React.ReactElement;
    form: React.ReactElement;
    bottomInformation: React.ReactElement;
}

const LoginTemplate = ({
    header,
    form,
    bottomInformation
}: LoginTemplateProps) => {
    return (
        <Center h={["100vh", "100vh"]}>
            <Card as={VStack} maxH={["100vh", "80vh"]} overflowY="auto">
                <Box w="full" p={4}>
                    {header}
                </Box>
                <Center p={4}>
                    {form}
                </Center>
                <Box p={4} mt={2}>
                    {bottomInformation}
                </Box>
            </Card>
        </Center>
    )
}

export default LoginTemplate